import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import type { BoxProps } from "@mui/material/Box";

import amex from "../assets/bandeira.amex.png";
import elo from "../assets/bandeira.elo.png";
import hipercard from "../assets/bandeira.hipercard.png";
import mastercard from "../assets/bandeira.mastercard.png";
import visa from "../assets/bandeira.visa.png";

const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexFlow: "row wrap",
  gap: theme.spacing(1),
  justifyContent: "center",
  alignItems: "center",
}));

type BandeirasCartoesProps = BoxProps & {
  imgHeight?: React.ImgHTMLAttributes<HTMLImageElement>["height"];
};

export default function BandeirasCartoes({
  imgHeight = 64,
  ...boxProps
}: BandeirasCartoesProps) {
  return (
    <StyledBox {...boxProps}>
      <img src={amex} height={imgHeight} />
      <img src={mastercard} height={imgHeight} />
      <img src={visa} height={imgHeight} />
      <img src={elo} height={imgHeight} />
      <img src={hipercard} height={imgHeight} />
    </StyledBox>
  );
}
